import { gql } from '@apollo/client'

export default gql(`
    mutation deletePerson($id: ID!, $name: String, $project: String) {
        deletePerson(
                id: $id,
                name: $name,
                project: $project
        ) {
            id
            name
        }
    }`
)
